// extracted by mini-css-extract-plugin
module.exports = {"enquiryBtnWrapper":"enquiry-fixed-button_enquiryBtnWrapper__8uez2","enquiryBtn":"enquiry-fixed-button_enquiryBtn__hwgjc"};